<template>
  <base-layout
    :readOnly="readOnly"
    :value="labelValue"
    :label-width="labelWidth"
    :text-align="textAlign"
    :style-type="styleType"
    :label="label"
    :is-dipatch="isDipatch"
  >
    <el-upload
      slot="control"
      class="base-upload-input"
      :data="uploadData"
      :action="action"
      :on-preview="handlePreview"
      :on-success="handleSuccess"
      :multiple="multiple"
      :on-remove="handleRemove"
      :show-file-list="showFileList"
      :file-list="fileList"
      :allowUploadType="allowUploadType"
      :headers="headers"
    >
      <a  v-if="clickType == 'alink'" :disabled="disabled||fileList.length >= this.max" size="small" type="primary">{{this.linkText}}</a>
      <el-button v-else :disabled="disabled||fileList.length >= this.max" size="small" type="primary">点击上传</el-button>
    </el-upload>
  </base-layout>
</template>

<script>
import baseLayout from "./base-layout.vue";
import { handleEmitValue, upload } from "./../props-config";
import { formatImgUrl } from "src/filter/modules/img";
import * as conf from "src/store/conf";
import {getCookie} from "@/store/utils";
export default {
  name: "base-upload",
  components: {
    baseLayout
  },
  computed: {
    fileList: {
      get() {
        if (Array.isArray(this.value) === false) {
          if (!this.value) return [];
          return [{ name: this.value, url: this.value }];
        } else {
          return this.value;
        }
      },
      set(val) {
        if (val.length >= this.max) {
          this.isMax = true;
        }
        return val;
      }
    },
    labelValue() {
      const array = this.value;
      if (Array.isArray(array) && array.length > 0) {
        return `<a target="_blank" href="${formatImgUrl(
          array[0].url
        )}">点击下载</a>`;
      } else if(array) {
        return `<a target="_blank" href="${formatImgUrl(
          array
        )}">${array}</a>`
      } else {
        return "";
      }
    }
  },
  props: {
    ...upload,
    type: {
      type: String,
      default: "text"
    },
    data: {
      type: Object,
      default: () => ({})
    },
    multiple: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 1
    },
    action: {
      type: String,
      default: conf.COMMON_FILE_UPLOAD
    },
    value: {
      type: [Array, String],
      default: () => []
    },
    isArray: {
      type: Boolean,
      default: true
    },
    showFileList: {
      type: Boolean,
      default: true
    },
    allowUploadType: {
      type: Array,
      default: ()=>[]
    },
    clickType: {
      type: String,
      default: 'btn'
    },
    linkText : {
      type: String,
      default: '点击上传'
    },
    headers: {
      type: Object,
      default: () => ({
        'AdminUserKey-Info': getCookie('AdminUserKey'),
        'AdminUserToken-Info': getCookie('AdminUserToken'),
        'Application-type': 'LC'
      })
    },
    uploadData: {
      type: Object,
      default: () => ({})
    },
  },
  mounted() {},
  methods: {
    handleEmitValue,
    handleSetValue(array) {
      if (this.isArray === true) {
        this.$emit("input", array);
        this.handleEmitValue(array);
      } else {
        if (Array.isArray(array) && array.length > 0) {
          this.$emit("input", array[0].url);
          this.handleEmitValue(array[0].url);
        } else {
          this.$emit("input", "");
          this.handleEmitValue("");
        }
      }
    },
    handleSuccess(response, file, fileList) {
      const downFile = {
        name: response.data.fileName,
        url: response.data.url
      };
      if (this.isArray === true) {
        if (this.fileList.length >= this.max) {
          return false;
        }
        this.handleSetValue([...this.fileList, downFile]);
      } else {
        this.handleSetValue([downFile]);
      }
    },
    handleRemove(file, fileList) {
      const index = this.fileList.findIndex(item => item == file);
      if (index > -1) {
        this.fileList.splice(index, 1);
      }
      if (this.isArray === true) {
        this.handleSetValue(this.fileList);
      } else {
        this.handleSetValue([this.fileList[0]]);
      }
      // this.handleSetValue(fileList.map(item => {
      //     return item.response.data
      // }))
    },
    handlePreview(file, fileList) {
      if (file.url) {
        window.open(formatImgUrl(file.url), "_blank");
      } else {
        window.open(formatImgUrl(file.response.data.url), "_blank");
      }
    }
  },
  data() {
    return {
      isMax: false
    };
  }
};
</script>
